<template>
  <div class="approveBox">
    <qx-card :title="title">
      <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" />
      <SubBtnBox @sub="sub" />
    </qx-card>
  </div>
</template>

<script>
import SubBtnBox from 'components/subBtnBox';
import {
  doSaveApplyRecord,
  doSaveApplyRecordInvite,
  doSaveApplyRecordArbitration,
} from 'api/car';
export default {
  components: {
    SubBtnBox,
  },
  props: {
    customPost: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      vehicleClassName: '',
      title: '',
      detailRes: {},
      type: '',
      baseForm: {
        form: [
        ],
        rules: {
        },
      },
    };
  },
  methods: {
    async setForm (detailRes, type) {
      let title = '';
      this.type = type;
      this.detailRes = detailRes;
      const vehicleClass = detailRes.vehicleClass;
      // 下面的显示隐藏其实逻辑是抄过来的，因为看得好懵
      if (type === 'apply') {
        // 再次申请
        if (vehicleClass === 2) {
          // 招商车
          title = '邀请成为招商车';
          // 需要提交邀请说明（applyRemark），附件
          this.setApplyForm(true);
        } else if (vehicleClass === 3 || vehicleClass === 5) {
          title = '邀请成为外调车';
          // 需要提交邀请说明（applyRemark），附件
          this.setApplyForm(true);
        } else if (vehicleClass === 1 || vehicleClass === 4) {
          title = '申请转移自有车司机';
          // 需要提交申请说明（applyRemark），运营证，行驶证
          this.setApplyForm(false);
        } else {
          // vehicleClass 为 null
          title = '申请转移自有车司机';
          // 需要提交申请说明（applyRemark），运营证，行驶证
          this.setApplyForm(false);
        }
      } else if (type === 'invite') {
        // 再次邀请
        if (vehicleClass === 2) {
          // 招商车
          title = '邀请成为招商车';
          this.setApplyForm(false);
        } else if (vehicleClass === 4) {
          title = '邀请成为挂靠车';
          this.setApplyForm(false);
        } else if (vehicleClass === 3) {
          title = '邀请成为外调车';
          this.setApplyForm(false);
        } else if (vehicleClass === 1) {
          title = '申请转移自有车司机';
          this.setApplyForm(true);
        } else {
          // vehicleClass 为 null
          title = '邀请成为外调车';
          this.setApplyForm(true);
        }
      } else if (type === 'arbitration') {
        // 申请平台仲裁
        title = '证件信息';
        this.setApplyForm(false);
      }
      this.title = title;
      // 如果没有 vehicleClass 则不显示
      if (vehicleClass === null) {
        this.title = '';
      }
      this.$refs.baseForm.setVal('applyRemark', detailRes.applyRemark);
    },
    // 设置提交表单
    async setApplyForm (flag) {
      if (flag) {
        this.baseForm = {
          form: [
            {
              label: '邀请说明',
              value: 'applyRemark',
              type: 'input',
              width: '430px',
              attr: {
                type: 'textarea',
                limit: 100,
              },
            },
            {
              label: '附件',
              value: 'applyFileIdInfo',
              type: 'img',
              accept: 'image/*',
              fileSize: 512000000,
              attr: {
                limit: 1,
              },
              default: [],
            },
          ],
          rules: {
            applyRemark: [
              { required: true, message: '请填写邀请说明', trigger: 'blur' },
            ],
          },
        };
      } else {
        this.baseForm = {
          form: [
            {
              label: '申请说明',
              value: 'applyRemark',
              type: 'input',
              width: '430px',
              attr: {
                type: 'textarea',
                limit: 100,
              },
            },
            {
              label: '运营证',
              value: 'drivingLicenseInfo',
              type: 'img',
              accept: 'image/*',
              fileSize: 512000000,
              attr: {
                limit: 1,
              },
              default: [],
            },
            {
              label: '行驶证',
              value: 'operCertiInfo',
              type: 'img',
              accept: 'image/*',
              fileSize: 512000000,
              attr: {
                limit: 1,
              },
              default: [],
            },
          ],
          rules: {
            applyRemark: [
              { required: true, message: '请填写申请说明', trigger: 'blur' },
            ],
          },
        };
      }
    },
    async sub () {
      let formData = await this.$refs.baseForm.sub();
      if (this.customPost) {
        this.$emit('sub', formData);
        return;
      }
      if (formData) {
        formData = {
          ...formData,
          ...this.detailRes,
        };
        if (formData.applyFileIdInfo && formData.applyFileIdInfo.length) {
          formData.applyFileId = formData.applyFileIdInfo[0].id;
          formData.applyFileUrl = formData.applyFileIdInfo[0].url;
        }
        if (formData.drivingLicenseInfo && formData.drivingLicenseInfo.length) {
          formData.drivingLicense = formData.drivingLicenseInfo[0].id;
          formData.drivingLicenseUrl = formData.drivingLicenseInfo[0].url;
        }
        if (formData.operCertiInfo && formData.operCertiInfo.length) {
          formData.operCerti = formData.operCertiInfo[0].id;
          formData.operCertiUrl = formData.operCertiInfo[0].url;
        }
        if (this.type === 'apply') {
          this.fnDoSaveApplyRecord(formData);
        } else if (this.type === 'invite') {
          this.fnDoSaveApplyRecordInvite(formData);
        } else if (this.type === 'arbitration') {
          this.fnDoSaveApplyRecordArbitration(formData);
        }
      }
    },
    fnShowMsgAndClose (message) {
      this.$alert(message, '温馨提示', {
        confirmButtonText: '确定',
      });
      this.close();
    },
    // 再次申请
    async fnDoSaveApplyRecord (formData) {
      const res = await doSaveApplyRecord(formData);
      if (!res.failed) {
        let message = '';
        if (this.detailRes.beApplyTenantId > 0) {
          message = '您提交的申请已发给车队处理，请耐心等待。可在邀请记录中查看审核结果。若对处理结果有异议可申请平台仲裁';
        } else {
          message = '您提交的申请已发给司机处理，请耐心等待。可在邀请记录中查看审核结果。若对处理结果有异议可申请平台仲裁';
        }
        this.fnShowMsgAndClose(message);
      }
    },
    // 再次邀请
    async fnDoSaveApplyRecordInvite (formData) {
      const res = await doSaveApplyRecordInvite(formData);
      if (!res.failed) {
        let message = '';
        if (this.detailRes.vehicleClass !== 3) {
          if (this.detailRes.beApplyTenantId > 0) {
            message = '您提交的申请已发给车队处理，请耐心等待。可在邀请记录中查看审核结果。';
          } else {
            message = '您提交的申请已发给司机处理，请耐心等待。可在邀请记录中查看审核结果。';
          }
        } else {
          message = '车辆邀请成功，可在车辆档案中查看';
        }
        this.fnShowMsgAndClose(message);
      }
    },
    // 申请平台仲裁
    async fnDoSaveApplyRecordArbitration (formData) {
      const res = await doSaveApplyRecordArbitration(formData);
      if (!res.failed) {
        this.fnShowMsgAndClose('平台已收到您提交的申请，并且努力正在处理中，请耐心等待。可在邀请记录中查看审核结果。');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.approveBox {
  padding-bottom: 56px;
}
</style>
